module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 5-18d13f4847f68645bb6ac780e4333bfc.jpg";